"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _icon = _interopRequireDefault(require("../icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function arrow(_ref) {
  var side = _ref.side,
      handleClick = _ref.handleClick;
  var className = side === "next" ? "slider-arrow arrow-next" : "slider-arrow arrow-prev";
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className,
    onClick: handleClick
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    icon: side === "next" ? "chevron-right" : "chevron-left"
  }));
}

arrow.propTypes = {
  side: _propTypes.default.string,
  handleClick: _propTypes.default.func
};
var _default = arrow;
exports.default = _default;